export const pushContentToMatomo = (uiEvent, uiPageName, uiComponent, uiAction, uiValue, contextData, uiComponentCustom ) => {

  if (sessionStorage.getItem("userData") != null )
  {
      let sessionKey = "oidc.user:" + process.env.IDENTITY_BASE_URL + ":" + process.env.CLIENT_ID
      var thisSession = JSON.parse(sessionStorage.getItem(sessionKey)) 
      contextData.impersonateAdminId = JSON.parse(sessionStorage.getItem("userData")).adminId
      thisSession.profile.UserID = JSON.parse(sessionStorage.getItem("userData")).id
      thisSession.profile.CompanyID = JSON.parse(sessionStorage.getItem("userData")).companyId
      thisSession.profile.CompanyName = JSON.parse(sessionStorage.getItem("userData")).companyName
      sessionStorage.setItem(sessionKey,JSON.stringify(thisSession))      
  }
    
  var dataLayerObj = {
    "UI_PageName": uiPageName,
    "UI_Component": uiComponent,
    "UI_Component_Custom": uiComponentCustom == undefined ? '' : uiComponentCustom,
    "UI_Event": uiEvent,
    "UI_Action": uiAction,
    "UI_Value": uiValue,
    "contextData": contextData
  };

  if (window["_mtm"] !== undefined && window["_mtm"] !== null) {
    window["_mtm"].push({
      'event': "dlv_track",
      'dlv_eventData': dataLayerObj
    });     
  }
}